import React, { useState, useContext } from 'react';
import useLocationQuery from 'hooks/useLocationQuery';
import PetProfileForm from '@chewy/pet-profile-form';
import { useHistory } from 'react-router';
import AnalyticsContext from 'context/AnalyticsContext';
import { queryKeyNewForm, queryKeyNewFormNoRefresh } from '../api/constant';
import { ApiPetProfile } from '../api/generated-client/PetProfile-Service-A.v1';
import { getPetEditPath, getPetsPath } from '../util/config';
import { conditionalHistoryPush } from '../util/helpers';

export default function NewPet() {
  return <NewPetForm />;
}

const NewPetForm = () => {
  const history = useHistory();
  const query = useLocationQuery();
  const analytics = useContext(AnalyticsContext);
  const queryOverrideToShowConfigForm: boolean = query.get(queryKeyNewFormNoRefresh) === 'true';
  const [petProfileId, setPetProfileId] = useState<number>();
  const onPetUpdate = (pet: ApiPetProfile) => {
    const petProfileId = pet.id;
    if (queryOverrideToShowConfigForm) {
      setPetProfileId(petProfileId);
    } else {
      conditionalHistoryPush(`${getPetEditPath(petProfileId)}?${queryKeyNewForm}=true`, history);
    }
  };

  const dismissCallback = () => {
    conditionalHistoryPush(getPetsPath(), history);
  };

  return (
    <PetProfileForm
      petProfileId={petProfileId}
      dismissCallback={dismissCallback}
      petUpdateSuccessCallback={onPetUpdate}
      analytics={{ segmentTrack: analytics.trackEvent }}
    />
  );
};
